<template>
    <div class="sidebar-menu primary">
        <emb-perfect-scrollbar class="scroll-area" :settings="settings">
            <v-list>
                <div class="close-btn-sidebar layout justify-end mx-4 pt-2">
                    <v-btn class="my-1" fab dark small color="pink" @click="toggleMobileSidebar">
						<v-icon dark x-small>mdi-close</v-icon>
					</v-btn>
                </div>
                <template v-for="menu in menus">
                    <template v-if="menu.children !== null">
                        <v-list-group light :key="menu.title" no-action v-model="menu.active">
                            <v-list-item class="px-0" slot="activator" :to="menu.path">
                                <v-list-item-action class="mr-0">
                                    <v-icon>{{ menu.icon }}</v-icon>
                                </v-list-item-action>
                                <v-list-item-title>
                                    {{ menu.name }}
                                </v-list-item-title>
                            </v-list-item>
                        </v-list-group>
                    </template>

                    <template v-else>
                        <v-list-item :key="menu.title" :to="menu.path">
                            <v-list-item-action class="mr-0">
                                <v-icon>{{ menu.icon }}</v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>
                                    {{ menu.name }}
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </template>
                </template>
            </v-list>
        </emb-perfect-scrollbar>
    </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import { mapGetters } from 'vuex';
export default {
    components: {
        embPerfectScrollbar: VuePerfectScrollbar,
    },
    data() {
        return {
            subGroup: {
                'message.men': false,
                'message.women': false,
                'message.gadgets': false,
                'message.accessories': false,
            },
            settings: {
                maxScrollbarLength: 360,
            },
        };
    },
    computed: {
        ...mapGetters(['menus']),
    },
    methods: {
        toggleMobileSidebar() {
            this.$store.dispatch('toggleSidebar', false);
        },
        scrollHanle(evt) {
            console.log(evt);
        },
    },
};
</script>
